const parse = (rawHref) => {
  const [href, hash] = rawHref.split("#");
  let matched = /^((https?:)\/\/([a-zA-Z0-9.%-]+):?([0-9]+)?)?(\/?[^?]*)?\??([^?]*)/.exec(
    href
  );
  if (!matched) {
    console.warn(`URL \uD615\uC2DD\uC774 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. (${href})`);
    matched = [];
  }
  const query = {};
  if (matched[6] !== "") {
    matched[6].split("&").forEach((raw) => {
      const [key, value] = raw.split("=");
      if (query[key]) {
        if (!Array.isArray(query[key])) {
          query[key] = [query[key]];
        }
        query[key].push(decodeURIComponent(value));
      } else {
        query[key] = decodeURIComponent(value);
      }
    });
  }
  const pathname = matched[5] ? decodeURIComponent(matched[5]) : "/";
  return {
    href: decodeURI(href),
    hash: hash ? `#${hash}` : "",
    query,
    origin: matched[2] && matched[3] ? decodeURI(
      `${matched[2]}//${matched[3]}${matched[4] === void 0 ? "" : `:${matched[4]}`}`
    ) : "",
    protocol: matched[2] || "",
    hostname: matched[3] ? decodeURI(matched[3]) : "",
    port: matched[4] ? `${matched[4]}` : "",
    pathname,
    search: matched[6] ? `?${matched[6]}` : ""
  };
};

export { parse };
//# sourceMappingURL=parse.mjs.map
